import { render, staticRenderFns } from "./Leads.vue?vue&type=template&id=26a96abe&scoped=true&"
import script from "./Leads.vue?vue&type=script&lang=js&"
export * from "./Leads.vue?vue&type=script&lang=js&"
import style0 from "./Leads.vue?vue&type=style&index=0&id=26a96abe&lang=scss&scoped=true&"
import style1 from "./Leads.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a96abe",
  null
  
)

export default component.exports